var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "step-icon",
      class: { pulse: _vm.checked, checked: _vm.checked },
    },
    [
      _vm.checked
        ? _c("font-awesome-icon", {
            staticClass: "icon",
            attrs: { icon: "check" },
          })
        : _c("font-awesome-icon", {
            staticClass: "icon",
            attrs: { icon: "exclamation" },
          }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }